import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "frame-30" }
const _hoisted_2 = { class: "frame-31" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "frame-32",
  alt: "Florisuite",
  src: "https://c.animaapp.com/nNxA75tB/img/frame-402-1.svg"
}, null, -1)
const _hoisted_4 = ["aria-expanded"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "nav-toggle-bar" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "nav-toggle-bar" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "nav-toggle-bar" }, null, -1)
const _hoisted_8 = [
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = { class: "frame-33" }
const _hoisted_10 = { class: "frame-34" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-wrapper-17" }, "Se connecter", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "d-marrer-l-essai-2" }, "Essai gratuit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['nav-wrapper', _ctx.className, { 'nav-menu-open': _ctx.menuOpen }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_RouterLink, {
          to: "/",
          class: "frame-32-link",
          "aria-label": "Accueil"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          type: "button",
          class: "nav-toggle",
          "aria-label": "Menu",
          "aria-expanded": _ctx.menuOpen,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.menuOpen = !_ctx.menuOpen))
        }, _hoisted_8, 8, _hoisted_4),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_RouterLink, {
            class: "text-wrapper-15",
            to: "/",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.menuOpen = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Accueil ")
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            class: "text-wrapper-16",
            to: "/fonctionnalites",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.menuOpen = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Fonctionnalités ")
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            class: "text-wrapper-16",
            to: "/tarifs",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.menuOpen = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Tarifs ")
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            class: "text-wrapper-16",
            to: "/contact",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.menuOpen = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Contact ")
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_RouterLink, {
            to: "/connexion",
            class: "button-2",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.menuOpen = false))
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          }),
          _createVNode(_component_RouterLink, {
            to: "/inscription",
            class: "d-marrer-l-essai-wrapper",
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.menuOpen = false))
          }, {
            default: _withCtx(() => [
              _hoisted_12
            ]),
            _: 1
          })
        ])
      ])
    ])
  ], 2))
}